"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUrl = exports.FabricIframe = exports.isFabricIframeObject = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var React = __importStar(require("react"));
var fabric_1 = require("fabric");
var react_dom_1 = require("react-dom");
var nanoid_1 = require("nanoid");
var fabricObjectUtils_1 = require("../../fabricObjectUtils");
var initCanvas_1 = require("../../init/initCanvas");
var elementStyles_1 = require("../../../../Components/Templates/CanvasContent/Elements/elementStyles");
var IframeWidget_1 = __importDefault(require("./IframeWidget"));
var isValidUrl = function (urlString) {
    try {
        var url = new URL(urlString);
        return url.protocol === 'http:' || url.protocol === 'https:';
    }
    catch (_) {
        return false;
    }
};
exports.isValidUrl = isValidUrl;
var isFabricIframeObject = function (item) {
    return (item === null || item === void 0 ? void 0 : item.type) === seesignage_utils_1.ObjectType.CustomIframe;
};
exports.isFabricIframeObject = isFabricIframeObject;
var FabricIframe = fabric_1.fabric.util.createClass(fabric_1.fabric.Rect, {
    type: seesignage_utils_1.ObjectType.CustomIframe,
    initialize: function (customOptions, options) {
        if (options === void 0) { options = {}; }
        this.callSuper('initialize', options);
        this.set({ customOptions: customOptions });
        this.set({
            fill: 'rgba(255, 255, 255, 0)',
            stroke: 'rgba(255, 255, 255, 0)'
        });
        // disable specific controls
        this.setControlsVisibility({
            // disable middle controls as those would break elements scaling
            mt: false,
            mb: false,
            ml: false,
            mr: false,
            mtr: false // rotation
        });
    },
    render: function (ctx, noTransform) {
        this.callSuper('render', ctx, noTransform);
        if (!this.widgetContainer) {
            this.createWidgetContainer();
            // make sure to render only if element exist, otherwise might cause render error
            this.renderWidget();
        }
        this.setWidgetContainerCoords();
    },
    createWidgetContainer: function () {
        var _a = this, id = _a.customOptions.id, type = _a.type;
        this.widgetContainer = fabric_1.fabric.util.makeElement('div', {
            id: "".concat(type, "-widget-container-").concat(id)
        });
        var container = document.getElementById(initCanvas_1.CANVAS_CONTAINER_ID);
        if (container) {
            container.appendChild(this.widgetContainer);
        }
    },
    setWidgetContainerCoords: function () {
        var _a = this, widgetContainer = _a.widgetContainer, canvas = _a.canvas, group = _a.group, scaleX = _a.scaleX, scaleY = _a.scaleY, width = _a.width, height = _a.height, left = _a.left, top = _a.top, angle = _a.angle;
        if (canvas) {
            var style = (0, elementStyles_1.generateFabricWidgetObjectContainerStyles)({
                canvas: canvas,
                group: group,
                scaleX: scaleX,
                scaleY: scaleY,
                width: width,
                height: height,
                left: left,
                top: top,
                angle: angle
            });
            widgetContainer === null || widgetContainer === void 0 ? void 0 : widgetContainer.setAttribute('style', style);
        }
    },
    setWidgetProps: function (widgetProps) {
        var customOptions = this.customOptions;
        var updateCustomOptions = __assign(__assign({}, customOptions), { widgetProps: widgetProps });
        this.set('customOptions', updateCustomOptions);
        this.renderWidget();
    },
    renderWidget: function () {
        var _a = this, widgetContainer = _a.widgetContainer, widgetProps = _a.customOptions.widgetProps;
        (0, react_dom_1.render)(React.createElement(IframeWidget_1.default, { iframeProps: widgetProps }), widgetContainer);
    },
    removeWidget: function () {
        var widgetContainer = this.widgetContainer;
        widgetContainer === null || widgetContainer === void 0 ? void 0 : widgetContainer.remove();
    },
    toObject: function (generalPropertiesToInclude) {
        if (generalPropertiesToInclude === void 0) { generalPropertiesToInclude = [seesignage_utils_1.CanvasSaveMode.toMemory]; }
        var customPropertiesToInclude = ['customOptions'];
        var propertiesToInclude = __spreadArray(__spreadArray([], generalPropertiesToInclude.slice(1), true), customPropertiesToInclude, true);
        return (0, fabricObjectUtils_1.toObject)(this, propertiesToInclude);
    }
});
exports.FabricIframe = FabricIframe;
FabricIframe.fromObject = function (combinedOptions, callback) {
    var customOptions = combinedOptions.customOptions, options = __rest(combinedOptions, ["customOptions"]);
    delete customOptions.editable;
    return callback(new FabricIframe(customOptions, options));
};
window.fabric[seesignage_utils_1.ObjectType.CustomIframe] = FabricIframe;
// Convert old type to new type
var migrateObject = {
    fromObject: function (combinedOptions, callback) {
        var _a = combinedOptions.cId, cId = _a === void 0 ? (0, nanoid_1.nanoid)() : _a, _b = combinedOptions.cIframeProps, cIframeProps = _b === void 0 ? {} : _b, cIframeSrc = combinedOptions.cIframeSrc, options = __rest(combinedOptions, ["cId", "cIframeProps", "cIframeSrc"]);
        delete options.type;
        delete options.cType;
        delete options.editable;
        delete options.superType;
        if (cIframeSrc) {
            cIframeProps.src = cIframeSrc;
        }
        return new FabricIframe.fromObject(__assign(__assign({}, options), { customOptions: { id: cId, version: '1.0', widgetProps: cIframeProps } }), callback);
    }
};
window.fabric.Iframe = migrateObject;
//# sourceMappingURL=IframeObject.js.map